import { Badge } from '@/components/ui/badge';

const CERTIFICATIONS = [
  {
    label: 'WCAG 2.2 AA',
    description: 'Accesibilidad web nivel AA conforme a las directrices WCAG 2.2',
  },
  {
    label: 'ISO/IEC 27001',
    description: 'Sistema de gestión de seguridad de la información',
  },
  {
    label: 'RGPD / LOPDGDD',
    description: 'Cumplimiento del Reglamento General de Protección de Datos',
  },
  {
    label: 'ENS nivel medio',
    description: 'Esquema Nacional de Seguridad',
  },
  {
    label: 'HTTPS / TLS 1.3',
    description: 'Comunicaciones cifradas con Subresource Integrity (SRI)',
  },
] as const;

export function ComplianceSection() {
  return (
    <section
      id="compliance"
      className="py-20 sm:py-28 bg-peninsula-graphite peninsula-texture-dark"
      aria-labelledby="compliance-heading"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-2xl text-center mb-12">
          <h2 id="compliance-heading" className="text-3xl font-bold tracking-tight text-white sm:text-4xl">
            Cumplimiento normativo
          </h2>
          <p className="mt-4 text-lg text-white/70">
            Cumplimos con los estándares más exigentes en accesibilidad, seguridad y protección de datos.
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-4 stagger-children">
          {CERTIFICATIONS.map((cert) => (
            <div
              key={cert.label}
              className="flex flex-col items-center gap-2 rounded-sm border border-white/10 bg-white/5 p-6 text-center min-w-[180px] max-w-[220px]"
            >
              <Badge className="border-peninsula-magma bg-transparent text-white text-sm px-3 py-1">
                {cert.label}
              </Badge>
              <p className="text-xs text-white/60 leading-relaxed">
                {cert.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
